<template>
    <div class="row">
        <div class="col-md-3 custom-sidebar py-5">
            <h4 class="side-navbar-title mb-4">HR Admin Portal</h4> <!-- Mustafijur: 09-104-2026: Core HR to HR Admin Portal-->
            <div class="panel-group side-navbar">
                <a href="#" target="_self" class="nav-link" :class="{ active: tabIndexRFParent == 0 }" @click.stop="open_item_selected(0)">Letter Templates</a>

                <a href="#" target="_self" class="nav-link" :class="{ active: tabIndexRFParent == 1 }" @click.stop="open_item_selected(1)">Certificates</a>

                <a href="#" target="_self" class="nav-link" :class="{ active: tabIndexRFParent == 2 }" @click.stop="open_item_selected(2)">Company Documents & Policies</a>

                <a href="#" target="_self" class="nav-link" :class="{ active: tabIndexRFParent == 3 }" @click.stop="open_item_selected(3)">Email Templates</a>
                <!-- <a href="#" target="_self" class="nav-link" :class="{ active: tabIndexRFParent == 3 }"
                    @click.stop="open_item_selected(3)">Onboarding</a> -->
                <!-- <a href="#" target="_self" class="nav-link" :class="{ active: tabIndexRFParent == 4 }"
                    @click.stop="open_item_selected(4)">Career Management</a> -->
                <!-- <a href="#" target="_self" class="nav-link" :class="{ active: tabIndexRFParent == 5 }"
                    @click.stop="open_item_selected(5)">Offboarding</a> -->
                <a href="#" target="_self" class="nav-link" :class="{ active: tabIndexRFParent == 4 }" @click.stop="open_item_selected(4)">NOC Application</a> <!-- Afrin: start NOC application  from here -->
            </div>
        </div>
        <div class="col-md-9 pr-0">
            <div class="users-style">
                <!-- <h4 class="atlhr-dashboard-title mt-10 px-0 mb-4 pl-3">HR Admin Portal<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / HR Admin Portal</span></h4> -->
                 <!-- Abdullah26 added this for dynamic tytle  -->
                <h4 class="atlhr-dashboard-title mt-10 px-0 mb-4 pl-3">{{ currentTabTitle }}<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / HR Admin Portal / {{ currentTabTitle }}</span></h4>
                <div class="regulatory-filing-tab payroll-reporting-tab col-md-12" id="nav-tabContent-intro">
                    <b-tabs content-class="mt-3 reports-tab-wrapper" nav-wrapper-class="mb-2 reports-tab-nav-wrapper d-none" v-model="tabIndexRFParent">

                        <!-- <b-tab  @click="handleChange()">
                            <template active v-if="$atl_company_package_title != 'Provident Fund Only'"  v-slot:title>Signatories</template>

                            <template v-else active v-slot:title> <b-icon icon="lock-fill" aria-hidden="true" class='lock-icon-trz-tab'></b-icon>Signatories</template>

                            <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                <p style="font-size: 15px; padding-bottom: 10px;">Get all your Company Signatories here! </p>
                                <company-signatory ></company-signatory>
                            </template>
                            <template v-else>
                                <lock-template ></lock-template>
                            </template>
                        </b-tab> -->
                        <b-tab  @click="handleChange()">
                            <template active v-if="$atl_company_package_title != 'Provident Fund Only'"  v-slot:title>Templates</template>
                            <template v-else active v-slot:title> <b-icon icon="lock-fill" aria-hidden="true" class='lock-icon-trz-tab'></b-icon>Templates</template>

                            <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                <div class="reports-tab-nav">
                                    <template v-if="$acl['templates/list'] > 0">
                                        <div class="row">
                                            <div class="col-8">
                                                <p style="font-size: 15px; padding-bottom: 10px;">Access and manage all your HR templates, certificates and documents in one place.</p>
                                            </div>
                                            <div class="col-4  text-right"  v-if="$acl['templates/list'] > 1">
                                                <b-button :href="$api_url+'/signatoryview'" class=''>Manage Signatories</b-button>
                                            </div>
                                        </div>
                                        <all-templates ></all-templates>
                                    </template>
                                    <template v-else>
                                        <lock-template ></lock-template>
                                    </template>
                                </div>
                            </template>
                            <template v-else>
                                <lock-template ></lock-template>
                            </template>
                        </b-tab>
                        <b-tab lazy  @click="handleChange()">
                            <template active v-if="$atl_company_package_title != 'Provident Fund Only'"  v-slot:title>Certificates</template>

                            <template v-else active v-slot:title> <b-icon icon="lock-fill" aria-hidden="true" class='lock-icon-trz-tab'></b-icon>Certificates</template>
                            <!--<p style="font-size: 15px; padding-bottom: 30px;">Description text will be here.</p>-->
                            <!--<div class="row no-margin">
                                <div class="col-md-6 col-sm-6 col-lg-4 col-xl-4 pl-0">
                                    <div class="card h-100">
                                        <div class="card-body">
                                            <div class="report-title w-100 border-bottom font-weight-bold pb-2 mb-2">
                                                <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>Contract Letters (coming soon)
                                            </div>
                                            <div class="report-intro">
                                                <ul class="list-group">
                                                    <li class="list-group-item border-0 py-1"><a href="#">Employment Contract</a></li>
                                                    <li class="list-group-item border-0 py-1"><a href="#">Contract Change Letter</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4 col-xl-4">
                                    <div class="card h-100">
                                        <div class="card-body">
                                            <div class="report-title w-100 border-bottom font-weight-bold pb-2 mb-2">
                                                <img v-bind:src="$api_url+'/images/Yearly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Yearly-report.png'" class="dark-mode-icon" width="50px"/>HR Certificates
                                            </div>
                                            <div class="report-intro">
                                                <ul class="list-group">
                                                    <li class="list-group-item border-0 py-1"><a href="#">Standard Salary Certificate (Current Salary) (coming soon)</a></li>
                                                    <li class="list-group-item border-0 py-1"><a :href="$api_url+'/core-hr/certificates'">Income Tax Deduction Certificate</a></li>
                                                    <li class="list-group-item border-0 py-1"><a :href="$api_url+'/core-hr/certificates'">Investment Declaration Letter</a></li>
                                                    <li class="list-group-item border-0 py-1"><a href="#">Standard Salary Certificate (Period Range) (coming soon)</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4 col-xl-4 pr-0">
                                    <div class="card h-100">
                                        <div class="card-body">
                                            <div class="report-title w-100 border-bottom font-weight-bold pb-2 mb-2">
                                                <img v-bind:src="$api_url+'/images/Comprehensive-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Comprehensive-report.png'" class="dark-mode-icon" width="50px"/>Leaver Certificates (coming soon)
                                            </div>
                                            <div class="report-intro">
                                                <ul class="list-group">
                                                    <li class="list-group-item border-0 py-1"><a href="#">Release Letter</a></li>
                                                    <li class="list-group-item border-0 py-1"><a href="#">Experience Certificate</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>-->
                            <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                <div class="reports-tab-nav"> <!-- Mustafijur Added Block: <div class="reports-tab-nav"> 09-04-2026 -->
                                    <template v-if="$acl['templates/list'] > 0">
                                        <p style="font-size: 15px; padding-bottom: 10px;">View, generate and manage all your official HR-related certificates.</p>
                                        <corehr-certificates ></corehr-certificates>
                                    </template>
                                    <template v-else>
                                        <lock-template ></lock-template>
                                    </template>
                                </div> <!-- Mustafijur End Block: </div> on 09-04-2026 -->

                            </template>
                            <template v-else>
                                <lock-template ></lock-template>
                            </template>
                        </b-tab>

                        <b-tab  lazy @click="handleChange()">
                            <template active v-if="$atl_company_package_title != 'Provident Fund Only'"  v-slot:title>Documents</template>

                            <template v-else active v-slot:title> <b-icon icon="lock-fill" aria-hidden="true" class='lock-icon-trz-tab'></b-icon>Documents</template>
                            <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                <template v-if="$acl['hr-policy-handbook'] > 0">
                                    <!-- alpha fix- commeted this  -->
                                    <!-- <p style="font-size: 15px; padding-bottom: 10px;">Upload, Centralize & Deploy official or departmental guidelines and employee handbooks instantly from one powerful command center.</p> -->
                                    <hr-policy-handbook  :flg="1"></hr-policy-handbook>
                                </template>
                                <template v-else>
                                    <lock-template ></lock-template>
                                </template>

                            </template>
                            <template v-else>
                                <lock-template ></lock-template>
                            </template>
                        </b-tab>

                        <!-- Updates for email template -->
                        <b-tab lazy @click="handleChange()">
                            <template active v-if="$atl_company_package_title != 'Provident Fund Only'"  v-slot:title>Email Templates</template>
                            <template v-else active v-slot:title> <b-icon icon="lock-fill" aria-hidden="true" class='lock-icon-trz-tab'></b-icon>Email Templates</template>
                            <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                <template v-if="$acl['templates/list'] > 0">
                                    <!-- alpha fix-commented this  -->
                                    <!-- <p style="font-size: 15px; padding-bottom: 10px;">Create, review and manage all your automated email notifications.</p> -->
                                    <email-templates></email-templates>
                                </template>
                                <template v-else>
                                    <lock-template ></lock-template>
                                </template>
                            </template>
                            <template v-else>
                                <lock-template ></lock-template>
                            </template>
                        </b-tab>
                        <!-- Updates for email template -->

                        <!-- Afrin: start NOC application  from here -->
                        <b-tab lazy @click="handleChange()">
                            <template active v-if="$atl_company_package_title != 'Provident Fund Only'" v-slot:title>NOC Application</template>
                            <template v-else active v-slot:title> <b-icon icon="lock-fill" aria-hidden="true"
                                    class='lock-icon-trz-tab'></b-icon>NOC Application</template>
                            <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                <!-- <h4 class="atlhr-dashboard-title mt-10 px-0 mb-4 pl-3">NOC Application<span>
                                    <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / HR Admin Portal / NOC Application</span>
                                </h4> -->

                                <template v-if="$acl['templates/list'] > 0">

                                    <div class="reports-tab-nav">
                                        <p style="font-size: 15px; padding-bottom: 10px;">Access and manage all employee NOC applications in one place.</p>
                                        <bulk-noc-documents :pageurl="$api_url"></bulk-noc-documents>
                                    </div>

                                </template>
                                <template v-else>
                                    <lock-template></lock-template>
                                </template>
                            </template>
                            <template v-else>
                                <lock-template></lock-template>
                            </template>
                        </b-tab>
                        <!-- Afrin: end NOC application -->

                    </b-tabs>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default
    {
        data()
        {
            return {
                tabIndexRFParent: 0, // Mustafijur Added:
                // Abdullah26 added this
                tabTitles: [
                    'Letter Templates',
                    'Certificates',
                    'Company Documents & Policies',
                    'Email Templates',
                    'NOC Application',
                ],
            }
        },
        // Abdullah26 added this
        computed: {
            currentTabTitle() {
                return this.tabTitles[this.tabIndexRFParent] || 'HR Admin Portal';
            }
        },
        methods:
        {
            open_item_selected: function (item) {
                this.tabIndexRFParent = item;
            },
            handleChange(){
                this.tabKey += 1;
            },

        },
        created()
        {

        },
    };
</script>
